export const
  TEXT     = 'text',
  EMAIL    = 'email',
  SEGMENTS = 'segments',
  LOCATION = 'location',
  PASSWORD = 'password';
